import { StrictMode } from 'react'
import i18n from './i18n'
import { localeFromPath } from './lib/locale'
import { createRoot, hydrateRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

i18n.changeLanguage(localeFromPath(window.location.pathname));
const root = document.getElementById('root')!;
const app = <StrictMode><App /></StrictMode>;
if (root.hasChildNodes()) {
  hydrateRoot(root, app);
} else {
  createRoot(root).render(app);
}
